export interface OnBoardingInvestisseurBusinessWorkflow {
    Code?: string,
    Libelle?: string,
    Order?: number
}


const  IDENTITE_REPRESENTANT: string = "IDR";
const  ADRESSE: string = "ADD";
const  EXPERIENCE_INVESTISSEMENT: string = "EXI";
const  BENEFICIAIRES_EFFECTIFS: string = "BNE";
const  PIECES_JUSTIFICATIVES: string = "PJS";
const  REMERCIEMENT = "REM";
    

export const OnBoardingInvestisseurBusinessWorkflow = {
    IDENTITE_REPRESENTANT,
    ADRESSE,
    EXPERIENCE_INVESTISSEMENT,
    BENEFICIAIRES_EFFECTIFS,
    PIECES_JUSTIFICATIVES,
    REMERCIEMENT,
}